import React, { ReactNode } from 'react';

import { ClassNameDecorator } from '../../../../../decorators';
import { ClassInjector } from '../../../../../injectors';

import './SecondaryHeading.scss';

interface Props {
  children: ReactNode;
}

const SecondaryHeading: ClassNameDecorator<Props> = ({ children, className }) => {
  return (
    <ClassInjector classNames="secondary-heading" oldClassName={className}>
      {children}
    </ClassInjector>
  );
};

export default SecondaryHeading;
